import React from "react"

import { NzeroLogo } from "@/components/logo/nzeroLogo"
import { primary800 } from "@/utils/colors"
import { MAIN_MENU_TOGGLE_HEIGHT } from "@/utils/constants"

import MenuRoundedIcon from "@mui/icons-material/MenuRounded"
import {
  Box,
  IconButton,
  Drawer as MuiDrawer,
  Stack,
  styled,
} from "@mui/material"

import { MainNavList } from "../main-nav-list"

interface NavigationDrawerProps {
  open: boolean
  toggleDrawer: () => void
}

const Drawer = styled(MuiDrawer)(({ theme }) => ({
  boxSizing: "border-box",
  flexShrink: 0,
  whiteSpace: "nowrap",
  "& .MuiDrawer-paper": {
    backgroundColor: primary800.toString(),
    borderRadius: 0,
    color: theme.palette.common.white,
  },
}))

export const NavigationDrawer = ({
  open,
  toggleDrawer,
}: NavigationDrawerProps) => {
  return (
    <Drawer data-testid="main-nav-drawer" open={open} onClose={toggleDrawer}>
      <Stack
        direction="row"
        sx={{
          alignContent: "center",
          justifyContent: "center",
          height: MAIN_MENU_TOGGLE_HEIGHT,
          minHeight: MAIN_MENU_TOGGLE_HEIGHT,
          padding: (theme) => theme.spacing(0, 0, 0, 1),
        }}
      >
        <IconButton
          aria-label="Menu"
          aria-pressed={open}
          color="inherit"
          onClick={toggleDrawer}
        >
          <MenuRoundedIcon />
        </IconButton>
        <Box sx={{ display: "flex", flex: 1, justifyContent: "center", pr: 2 }}>
          <NzeroLogo width={92} />
        </Box>
      </Stack>
      <MainNavList />
    </Drawer>
  )
}
